import React, { useState } from 'react';
import Grid from 'components/core/Grid';
import ModalContainer from 'components/component-library/ModalContainer';
import { ModalAnimated } from 'components/component-library/ModalAnimated';
import { List } from 'components/component-library/List';
import Typography from 'components/Typography';

import { Link, Outlet, useParams } from 'react-router-dom';
import { Header, Wrapper } from 'components/styled/common';
import { RoleProvider, ResourceProvider } from 'components/iam/ManageRoles/Context';
import { CA_PRODUCT_CODES } from 'constants/AppConstants';
import { getColor } from 'components/core/theme/colors';

const allowedCodes = [
    CA_PRODUCT_CODES.USS,
    CA_PRODUCT_CODES.COLENDING,
    CA_PRODUCT_CODES.BILL_DISCOUNTING,
];

const IAMWrapper: React.FC<{
    show: boolean;
    onClose(): void;
    productId: any;
    children: React.ReactNode;
}> = ({ show, onClose, children, productId }) => {
    return (
        <ResourceProvider productId={productId}>
            <RoleProvider>
                <ModalContainer>
                    <Wrapper className="open">
                        <ModalAnimated show={show} onDestroy={onClose}>
                            {children}
                        </ModalAnimated>
                    </Wrapper>
                </ModalContainer>
            </RoleProvider>
        </ResourceProvider>
    );
};

export const IAMList: React.FC<any & { onClose(): void; productId: string }> = ({
    onClose,
    productId,
}) => {
    const [show, toggle] = useState(true);
    return (
        <>
            <Header>
                <Grid container alignItems="center" justify="space-between">
                    <Grid item container alignItems="center">
                        <Typography variant="h4" weight="bold" color={getColor('grey', '900')}>
                            Manage Users
                        </Typography>
                    </Grid>
                </Grid>
            </Header>
            <Grid container justify="center">
                <List.LargeList>
                    <List.LargeListItem>
                        <Link to={`manage-roles`}>
                            <Typography
                                variant="subHeading"
                                weight="bold"
                                color={getColor('grey', '900')}
                            >
                                Manage Role
                            </Typography>
                            <Typography variant="body" color={getColor('grey', '500')}>
                                Yubi is an online marketplace for corporate borrowers and debt
                                investors to interact transparently and efficiently.
                            </Typography>
                        </Link>
                    </List.LargeListItem>
                    <List.LargeListItem>
                        <Link to={`manage-users`}>
                            <Typography
                                variant="subHeading"
                                weight="bold"
                                color={getColor('grey', '900')}
                            >
                                Manage Users
                            </Typography>
                            <Typography variant="body" color={getColor('grey', '500')}>
                                Yubi is an online marketplace for corporate borrowers and debt
                                investors to interact transparently and efficiently.
                            </Typography>
                        </Link>
                    </List.LargeListItem>
                </List.LargeList>
            </Grid>
        </>
    );
};

const IAMContainer = () => {
    const props = useParams();
    const { productCode } = props;

    return (
        <IAMWrapper {...props} onClose={() => {}} show productId={productCode}>
            <Outlet />
        </IAMWrapper>
    );
};

export default IAMContainer;
